import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("一年期")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("三年期")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("终身")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("普通功能组")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("优惠功能组")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("行业功能组")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("返回")

import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { api } from "@/apis/user";
import { ElMessage } from "element-plus";
// 数据定义

interface stateTypes {
  funcList: { id: number; name: String }[];
}
interface stateForm {
  name: any;
  remarks: any;
  fidList: any;
  type: any;
  adminAmount: any;
  pttAmount: any;
  id: any;
  months: any;
  currencyType: any;
  industryAmount: any;
  permanentAmount: any;
}

export default _defineComponent({
  expose: [],
  setup(__props) {

const dataList = reactive<stateTypes>({
  funcList: []
});
const route = useRoute();
const routerList = useRouter();
const listQuery = {
  page: {
    pageNo: 1,
    pageSize: 1000
  }
};
// 表单验证
const rules = reactive({
  name: [
    { required: true, message: "请填写功能组名称", trigger: "blur" },
    { min: 2, max: 16, message: "账号长度应该在2到16位之间", trigger: "blur" }
  ],
  remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
  fidList: [{ required: true, message: "请选择功能", trigger: "change" }],
  adminAmount: [{ required: true, message: "请输入价格", trigger: "blur" }],
  pttAmount: [{ required: true, message: "请输入价格", trigger: "blur" }],
  type: [{ required: true, message: "请选择功能", trigger: "change" }],
  months: [{ required: true, message: "请填写有效月份", trigger: "blur" }],
  industryAmount: [{ required: true, message: "请输入价格", trigger: "blur" }],
  permanentAmount: [{ required: true, message: "请输入价格", trigger: "blur" }],
  currencyType: [{ required: true, message: "请选择功能类型", trigger: "change" }]
});
const groupForm = ref();

const form = reactive<stateForm>({
  name: "",
  id: "",
  remarks: "",
  fidList: [],
  type: ref(0),
  adminAmount: null,
  pttAmount: null,
  months: 0,
  currencyType: 11,
  industryAmount: null,
  permanentAmount: null,
});
// 初始化成员数据
const getFuncList = async () => {
  const { data }: any = await api.list.funcList(listQuery);
  dataList.funcList = data.data.resultList;
};
// 返回
const returnList = () => {
  routerList.push({ path: "/funcgrouplist" });
};
// 查详情

const getDetail = async (id: any) => {
  const { data }: any = await api.revise.groupDetail({ id: id });
  console.log('data',data);
  let { name, remarks, type, adminAmount, pttAmount, months, currencyType, industryAmount, permanentAmount  } = data.data;
  console.log(name, remarks, type, adminAmount, pttAmount, months);
  form.id = id;
  form.name = name;
  form.adminAmount = adminAmount;
  form.remarks = remarks;
  form.months = months;
  form.pttAmount = pttAmount;
  form.type = type;
  data.data.functions.map((item: any) => {
    console.log(item);
    form.fidList.push(item.id);
  });
  form.currencyType = currencyType;
  form.industryAmount = industryAmount;
  form.permanentAmount = permanentAmount
};
// 提交
const submit = () => {
  console.log('submit?',form)
  groupForm.value.validate(async (valid: any) => {
    if (form.id !== "") {
      // 修改功能组信息
      if (valid) {
        const status: any = await api.revise.updattegroupfunc(form);
        if (status.data.status === 200) {
          routerList.push({ path: "/funcgrouplist" });
          ElMessage.success("修改成功");
        } else {
          return;
        }
      }
    } else {
      // 新建功能组
      if (valid) {
        console.log('else',form);
        const status: any = await api.revise.creategroupfunc(form);
        if (status.data.status === 200) {
          routerList.push({ path: "/funcgrouplist" });
          ElMessage.success("添加成功");
        } else {
          return;
        }
      }
    }
  });
};

onMounted(() => {
  getFuncList();
  if (route.query.id) {
    getDetail(route.query.id);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: form,
      "label-width": "150px",
      rules: rules,
      ref: groupForm,
      style: {"width":"80%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "功能组名称：",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (form.name = $event)),
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "虚拟币数量：",
          prop: "pttAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.pttAmount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (form.pttAmount = $event)),
              modelModifiers: { number: true },
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "行业币数量：",
          prop: "industryAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.industryAmount,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (form.industryAmount = $event)),
              modelModifiers: { number: true },
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "终身币数量：",
          prop: "permanentAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.permanentAmount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (form.permanentAmount = $event)),
              modelModifiers: { number: true },
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "管理员虚拟币数量：",
          prop: "adminAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.adminAmount,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (form.adminAmount = $event)),
              modelModifiers: { number: true },
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "功能：",
          prop: "fidList"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: form.fidList,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (form.fidList = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataList.funcList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: item.id,
                    label: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "币类型",
          prop: "currencyType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: form.currencyType,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (form.currencyType = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 11 }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 4 }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "月份：",
          prop: "months"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.months,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (form.months = $event)),
              modelModifiers: { number: true },
              maxlength: "3"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注：",
          prop: "remarks"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.remarks,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (form.remarks = $event)),
              placeholder: "少于两百字",
              type: "textarea",
              maxlength: "200"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "功能组类型：",
          prop: "type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: form.type,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (form.type = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 2 }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (submit())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (returnList()))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}
}

})